
import { defineComponent, PropType, reactive } from 'vue'

// types
import { OneCDelivery } from '@/core/types/one_c.types'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// realisations
import { onec } from '@/core/realisations/onec.realisation'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    props: {
        item: {
            type: Object as PropType<OneCDelivery>,
            required: true,
        },
    },
    components: {
        'the-button': TheButton,
    },
    setup(props) {
        const state = reactive({
            is_loading: false,
        })

        const notifications = useNotifications()

        const resend = async () => {
            try {
                state.is_loading = true
                await onec.resendDeliveryById(props.item.id)

                notifications.notify({ title: 'Успешно переотправлен!', type: 'success' })
            } catch (error) {
                notifications.notify({
                    title: 'При переотправке произошла ошибка',
                    type: 'danger',
                })
            } finally {
                state.is_loading = false
            }
        }

        const formatDate = (dateStr: string) => {
            if (!dateStr) return '-'

            const dateFirst = dateStr.split(' ')[0]
            const dateSecond = dateStr.split(' ')[1]
            return dateFirst.split('-').reverse().join('.') + ' ' + dateSecond
        }

        return { state, resend, formatDate }
    },
})
